import axios from 'axios';

export default {
  getLayerTypes: () => axios.get('/maps/layertypes'),
  getLayerTypeDetails: id => axios.get(`/maps/layertypes/${id}`),
  saveLayerType: data => axios.post('/maps/layertypes', data),
  updateLayerType: data => axios.put(`/maps/layertypes/${data.id}`, data),
  deleteLayerType: id => axios.delete(`/maps/layertypes/${id}`),
};
